"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        // eslint-disable-next-line no-console
        if (initialState === undefined) this.board = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        else this.board = initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        if (this.status !== "playing" && this.status !== "win") return;
        const boardBefore = JSON.stringify(this.board);
        for(let i = 0; i < this.board.length; i++)this.board[i] = this.slideAndMerge(this.board[i]);
        this.lostAndChangesOnAfterMove(boardBefore);
    }
    moveRight() {
        if (this.status !== "playing" && this.status !== "win") return;
        const boardBefore = JSON.stringify(this.board);
        for(let i = 0; i < this.board.length; i++){
            const reversedRow = [
                ...this.board[i]
            ].reverse();
            const backToRight = this.slideAndMerge(reversedRow).reverse();
            this.board[i] = backToRight;
        }
        this.lostAndChangesOnAfterMove(boardBefore);
    }
    moveUp() {
        if (this.status !== "playing" && this.status !== "win") return;
        const boardBefore = JSON.stringify(this.board);
        for(let i = 0; i < this.board.length; i++){
            const column = [];
            for(let j = 0; j < this.board.length; j++)column.push(this.board[j][i]);
            const processed = this.slideAndMerge(column);
            for(let j = 0; j < this.board.length; j++)this.board[j][i] = processed[j];
        }
        this.lostAndChangesOnAfterMove(boardBefore);
    }
    moveDown() {
        if (this.status !== "playing" && this.status !== "win") return;
        const boardBefore = JSON.stringify(this.board);
        for(let i = 0; i < this.board.length; i++){
            const column = [];
            for(let j = 0; j < this.board.length; j++)column.push(this.board[j][i]);
            const processed = this.slideAndMerge(column.reverse()).reverse();
            for(let j = 0; j < this.board.length; j++)this.board[j][i] = processed[j];
        }
        this.lostAndChangesOnAfterMove(boardBefore);
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.board;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        this.status = "playing";
        if (this.getEmptyCells().length === 16) {
            this.addRandomBlock();
            this.addRandomBlock();
        }
    }
    /**
   * Resets the game.
   */ restart() {
        this.clearTheBoard();
        this.score = 0;
        this.start();
    }
    // Add your own methods here
    addRandomBlock() {
        const rowsAndColumns = this.getEmptyCells();
        if (rowsAndColumns.length >= 1) {
            const randomIndex = Math.floor(Math.random() * rowsAndColumns.length);
            const ratio = Math.random() * 100;
            const el = rowsAndColumns[randomIndex];
            if (ratio > 90) this.board[el[0]][el[1]] = 4;
            else this.board[el[0]][el[1]] = 2;
        }
    }
    getEmptyCells() {
        const rowsAndColumns = [];
        for(let i = 0; i < this.board.length; i++){
            for(let j = 0; j < this.board[0].length; j++)if (this.board[i][j] === 0) rowsAndColumns.push([
                i,
                j
            ]);
        }
        return rowsAndColumns;
    }
    clearTheBoard() {
        for(let i = 0; i < this.board.length; i++)for(let j = 0; j < this.board[0].length; j++)this.board[i][j] = 0;
    }
    slideAndMerge(row) {
        const filtered = row.filter((el)=>el !== 0);
        const merged = [];
        for(let j = 0; j < filtered.length; j++){
            const cur = filtered[j];
            const next = filtered[j + 1];
            if (cur === next) {
                merged.push(cur + next);
                this.score += cur + next;
                if (cur + next === 2048) this.status = "win";
                j++;
            } else merged.push(cur);
        }
        while(merged.length < 4)merged.push(0);
        return merged;
    }
    checkChanges(boardBefore) {
        const boardAfter = JSON.stringify(this.board);
        if (boardBefore !== boardAfter) return true;
        return false;
    }
    isGameLost() {
        if (this.getEmptyCells().length > 0) return false;
        for(let i = 0; i < this.board.length; i++)for(let j = 0; j < this.board[0].length - 1; j++){
            if (this.board[i][j] === this.board[i][j + 1]) return false;
            if (this.board[j][i] === this.board[j + 1][i]) return false;
        }
        return true;
    }
    lostAndChangesOnAfterMove(boardBefore) {
        if (this.checkChanges(boardBefore)) {
            this.addRandomBlock();
            if (this.status !== "win" && this.isGameLost()) this.status = "lose";
        }
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
// Write your code here
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$score = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$button.textContent === "Start") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$changeBoard();
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$changeBoard();
    }
});
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$button.textContent === "Start") {
        $09e991522ca7e64e$var$button.textContent = "Restart";
        $09e991522ca7e64e$var$button.classList.replace("start", "restart");
    }
    if (e.key === "ArrowLeft") $09e991522ca7e64e$var$game.moveLeft();
    if (e.key === "ArrowRight") $09e991522ca7e64e$var$game.moveRight();
    if (e.key === "ArrowUp") $09e991522ca7e64e$var$game.moveUp();
    if (e.key === "ArrowDown") $09e991522ca7e64e$var$game.moveDown();
    $09e991522ca7e64e$var$changeBoard();
});
function $09e991522ca7e64e$var$changeBoard() {
    const allCells = document.querySelectorAll(".field-cell");
    const board = $09e991522ca7e64e$var$game.getState();
    for(let i = 0; i < board.length; i++)for(let j = 0; j < board[0].length; j++){
        const value = board[i][j];
        const index = i * board[0].length + j;
        allCells[index].classList.forEach((className)=>{
            if (className.startsWith("field-cell--")) allCells[index].classList.remove(className);
        });
        if (value === 0) allCells[index].textContent = "";
        if (value !== 0) {
            allCells[index].textContent = value;
            allCells[index].classList.add("field-cell--" + value);
        }
    }
    $09e991522ca7e64e$var$score.textContent = $09e991522ca7e64e$var$game.getScore();
    if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    else if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    else {
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    }
}


//# sourceMappingURL=index.dcc25de7.js.map
